export function addEventListeners (el, evts, fn, ...rest) {
  evts.split(' ').forEach(evt => el.addEventListener(evt, fn, rest))
}

export function removeEventListeners(el, evts, fn, ...rest) {
  evts.split(' ').forEach(evt => el.removeEventListener(evt, fn, rest))
}
